import { ApplicationSetupPage } from '@page/application-setup/application-setup.page';
import { OverviewPage } from '@page/overview/overview.page';

import { ApplicationStepsAside } from '@component/aside/application-steps/application-steps.aside';
import { EmptyNavigationAside } from '@component/aside/navigation/empty-navigation.aside';
import { Header } from '@component/header/header';
import { RouteEnum } from '@enum/route.enum';
import { RouteConfigInterface } from '@interface/route/route.interface';
import { pageNameLoader } from '@util/route/page-name-loader';

export const ApplicationsRoutes: RouteConfigInterface[] = [
  {
    ...pageNameLoader(RouteEnum.Overview),
    element: <OverviewPage />,
    Aside: EmptyNavigationAside,
    Header,
  },
  {
    Aside: () => <ApplicationStepsAside />,
    element: <ApplicationSetupPage />,
    ...pageNameLoader(RouteEnum.ApplicationSetup),
  },
  {
    Aside: () => <ApplicationStepsAside step={1} />,
    element: <ApplicationSetupPage />,
    ...pageNameLoader(RouteEnum.ApplicationSetupConnectors),
  },
  {
    Aside: () => <ApplicationStepsAside step={2} />,
    element: <ApplicationSetupPage />,
    ...pageNameLoader(RouteEnum.ApplicationSetupConsumer),
  },
  {
    Aside: () => <ApplicationStepsAside step={3} />,
    element: <ApplicationSetupPage />,
    ...pageNameLoader(RouteEnum.ApplicationSetupNext),
  },
];
